import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const useTableCellStyles = makeStyles(theme => ({
  tableCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    border: 'none',
    fontSize: props => props.variant === 'head' ? 12 : 16,
    color: props => props.variant === 'head' ? '#908F90' : '#3e3e3e',
    textTransform: props => props.variant === 'head' ? 'uppercase' : 'inherit',
  },
  emailCell: {
    width: '100%',
    maxWidth: 400,
  },
  inherited: {
    paddingLeft: 20,
  },
  timesSharedCell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'inherit',
    paddingRight: 36,
  },
  lastSentHeadCell: {
    paddingLeft: 35,
  }
}))

function ShareReportTableCell({ inherited, children, ...other }) {
  const classes = useTableCellStyles(other);
  return (
    <TableCell 
      className={classnames(
        classes.tableCell, { 
          [classes.emailCell]: other['data-email'],
          [classes.timesSharedCell]: other['data-times-shared'] && other.variant === 'body',
          [classes.lastSentHeadCell]: other['data-last-sent'] && other.variant === 'head',
          [classes.inherited]: (other['data-email'] || other['data-times-shared']) && inherited,
        }
      )}
      {...other}
    >
      {children}
    </TableCell>
  );
}

ShareReportTableCell.propTypes = {
  inherited: PropTypes.bool,
  children: PropTypes.any,
  other: PropTypes.object,
}

export default ShareReportTableCell;


// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/ShareReport/components/ShareReportTableCell.jsx